import React from "react";
import { Helmet } from "react-helmet-async"; // Correct import

const DOMAIN = '';
const MAIN_KEYWORDS = '';

const DEFAULT_IMAGE_CARD = 'https://superbworldtrip.com/assets/logo-BbOaJed0.webp';
const DEFAULT_TITLE = '';
const DEFAULT_DESCRIPTION = '';

const FAVICON_SOURCE = 'https://superbworldtrip.com/src/assets/images/logo/favicon.webp';

const POSTFIX_TITLE = '';

export default function Seo({
     title = DEFAULT_TITLE,
     description = DEFAULT_DESCRIPTION,
     link,
     keywords,
     imageCard = DEFAULT_IMAGE_CARD,
     largeTwitterCard,
     addPostfixTitle,
     noIndex,
     children
}) {
  let metaTitle;
  if (addPostfixTitle) {
    metaTitle = addPostfixTitle + title;
  } else {
    metaTitle = title;
  }

  const metaDesc = description;
  const metaLink = DOMAIN + link;
  const metaKeywords = keywords?.length > 0 ? keywords : MAIN_KEYWORDS;
  const isProd = import.meta.env.VITE_REACT_APP_ENV == "production";

  let metaImageCard;
  if (imageCard.startsWith("http")) {
    metaImageCard = imageCard;
  } else {
    metaImageCard = DOMAIN + imageCard;
  }

  const metaRobots = isProd ? "index, follow" : "noindex, nofollow";
  const twitterCardType = largeTwitterCard ? "summary_large_image" : "summary";

  return (
    <Helmet>
      <html lang="en"></html>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDesc} />
      {/* <meta name="canonical" content={metaLink} /> */}
      <meta name="keywords" content={metaKeywords} />
      <meta name="robots" content={metaRobots} />
      <meta name="icon" content={FAVICON_SOURCE} />

      {/* OG Tags*/}
      <meta property="og:url" content={metaLink} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDesc} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={metaImageCard} />

      {/* Twitter Tags*/}
      <meta property="twitter:site" content="@SuperbWorldTrip" />
      <meta property="twitter:title" content={metaTitle} />
      <meta property="twitter:description" content={metaDesc} />
      <meta property="twitter:creator" content="SuperbWorldTrip" />
      <meta property="twitter:card" content={twitterCardType} />
      <meta property="twitter:image" content={metaImageCard} />

      <meta property="referrer" content="origin-when-crossorigin" />

      {children}
    </Helmet>
  );
}